module.exports = __webpack_public_path__ + "img/favicon.57a7be28.png";